export default __webpack_public_path__ + "static/difficulty-00cec29b71cd1f094a1d0244b5296603.png";